import { useMutation, useQueryClient } from "@tanstack/react-query";
import { bulkImportClientsAction } from "../actions/bulkImportClients.action";
import { IBulkImportClientsResponse, IClientImportRow } from "../interfaces/Client.interface";

export interface IUseBulkImportClientsMutationOptions {
  onSuccess?: (data: IBulkImportClientsResponse) => void;
  onError?: (error: unknown) => void;
}

export function useBulkImportClientsMutation(options?: IUseBulkImportClientsMutationOptions) {
  const queryClient = useQueryClient();

  return useMutation<IBulkImportClientsResponse, unknown, { clients: IClientImportRow[]; status?: string }>({
    mutationFn: bulkImportClientsAction,
    onSuccess: async (data) => {
      await queryClient.invalidateQueries({
        queryKey: ["clients"],
      });

      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
}
